export default "__VITE_ASSET__YkANTiu98W3_QItMM2GuGA__"